import { cn } from '../../utils/cn';

// FieldLabel — uppercase tracking-wider field label, with optional leading icon.
// Pattern used across myAccount / HoldingCompanyForm / settings forms.
//
// Props:
//   - icon?: ReactNode (small lucide icon)
//   - children: label text
//   - htmlFor?: string
//   - className?: string

export function FieldLabel({ icon, children, htmlFor, className, ...rest }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'text-[11px] font-semibold text-fg-muted uppercase tracking-wider',
        icon ? 'flex items-center gap-1.5' : 'block',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </label>
  );
}

FieldLabel.displayName = 'FieldLabel';

export default FieldLabel;
